import React, { useEffect, useState } from "react";
import { Grid, Paper, Typography, Box } from "@mui/material";
import DoneAllTwoToneIcon from "@mui/icons-material/DoneAllTwoTone";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";
import GroupsIcon from "@mui/icons-material/Groups";
import { fetchData } from "@utils/functions";
import { useSelector } from "react-redux";


const useCountUp = (end, duration = 1000) => {

  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const increment = end / (duration / 16);
    const step = () => {
      start += increment;
      if (start < end) {
        setCount(Math.ceil(start));
        requestAnimationFrame(step);
      } else {
        setCount(end);
      }
    };
    requestAnimationFrame(step);
  }, [end, duration]);

  return count;
};

const AnimatedCard = ({ card }) => {
  const count = useCountUp(card.count, 1000);

  return (
    <Grid
      item
      xs={12}
      sm={6}
      md={3}
      sx={{
        display: "flex",
        padding: "8px !important",
        flexGrow: 1,
        minWidth: {
          xs: "100%",
          sm: "calc(50% - 16px)",
          md: "calc(25% - 16px)",
        },
      }}
    >
      <Paper
        elevation={3}
        sx={{
          backgroundColor: card.bgColor,
          color: "#fff",
          padding: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          borderRadius: 2,
          width: "100%",
          height: "100%",
        }}
      >
        <Box>{card.icon}</Box>
        <Box textAlign="left">
          <Typography variant="h4" id={card.id}>
            {count}
          </Typography>
          <Typography
            variant="subtitle2"
            sx={{ color: "rgba(255,255,255,0.8)", fontWeight: "bold" }}
          >
            {card.label}
          </Typography>
        </Box>
      </Paper>
    </Grid>
  );
};

const DashboardCards = () => {
  const villageCount = useSelector(state => state.dashboard?.villageCount ?? 0);
  const houseHoldCount = useSelector(state => state.dashboard?.houseHoldCount ?? 0);
  const houseHoldCompleteCount = useSelector(state => state.dashboard?.houseHoldCompleteCount ?? 0);
  const [cardData, setCardData] = useState([
    {
      id: "villageCount",
      count: 0,
      label: "TOTAL VILLAGES",
      icon: (
        <DoneAllTwoToneIcon
          fontSize="inherit"
          sx={{ color: "white", fontSize: 60 }}
        />
      ),
      bgColor: "#2D9CDB",
    },
    {
      id: "householdInformationCount",
      count: 0,
      label: "TOTAL HOUSEHOLDS",
      icon: (
        <HomeWorkIcon
          fontSize="inherit"
          sx={{ color: "white", fontSize: 60 }}
        />
      ),
      bgColor: "oklch(0.437 0.078 188.216)",
    },
    {
      id: "completedHouseholdCount",
      count: 0,
      label: "SURVEY COMPLETED",
      icon: (
        <TravelExploreIcon
          fontSize="inherit"
          sx={{ color: "white", fontSize: 60 }}
        />
      ),
      bgColor: "#2C3E50",
    },
    {
      id: "householdSocialTransferCount",
      count: 0,
      label: "SOCIAL TRANSFERS",
      icon: (
        <GroupsIcon fontSize="inherit" sx={{ color: "white", fontSize: 60 }} />
      ),
      bgColor: "oklch(0.705 0.213 47.604)",
    },
  ]);

  useEffect(() => {
    setCardData(prevCards =>
      prevCards.map(card => {
        if (card.id === "villageCount") {
          return { ...card, count: villageCount };
        } else if (card.id === "householdInformationCount") {
          return { ...card, count: houseHoldCount };
        } else if (card.id === "completedHouseholdCount") {
          return { ...card, count: houseHoldCompleteCount };
        }else {
          return card;
        }
      })
    );
  }, [villageCount, houseHoldCount,houseHoldCompleteCount]);
  
  

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const response = await fetchData("dashboard-card-count", "GET");
        if (response?.success && response?.data) {
          const counts = response.data;
          const updatedCards = cardData.map((card) => ({
            ...card,
            count: counts[card.id] || 0,
          }));
          setCardData(updatedCards);
        }
      } catch (error) {
        console.error("Failed to fetch dashboard card count", error);
      }
    };

    fetchDashboardData();
  }, []);

  return (
    <Box sx={{ width: "100%" }}>
      <Grid container spacing={0} sx={{ width: "100%" }}>
        {cardData.map((card) => (
          <AnimatedCard card={card} key={card.id} />
        ))}
      </Grid>
    </Box>
  );
};

export default DashboardCards;
